const CreateRoom = ({
  openCreateFunc,
  roomInput,
  onInputChange,
  createRoom,
  t,
}) => {
  const onKeyDownCreate = (event) => {
    if (event.key === "Enter") {
      createRoom();
    }
  };

  return (
    <div className="App-header">
      <div className="container-row-start lift-topbar">
        <div
          className="button-tertiary-m button-text-m text-color-black"
          onClick={() => openCreateFunc("")}
          style={{ maxHeight: "32.5px" }}
        >
          {t("back")}
        </div>
      </div>
      <div className="container">
        <input
          className="button-primary shadow-black text-h3 bottom-margin-l"
          autoComplete="off"
          type="text"
          maxLength="18"
          value={roomInput}
          onChange={onInputChange}
          onKeyDown={onKeyDownCreate}
          placeholder={t("room-id")}
        ></input>
        <div
          className="button-primary black-fill button-text-l text-color-pink shadow-pink box-button-center"
          onClick={createRoom}
        >
          {t("create")}
        </div>
      </div>
    </div>
  );
};

export default CreateRoom;
